/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PartUrl } from './partUrl';

export interface PresignOut {
  upload_token: string;
  conversation_id: string;
  upload_id: string;
  part_size: number;
  part_urls: PartUrl[];
  expires_at: string;
}
